module.exports = __webpack_public_path__ + "img/Card_diamond_K.abe229c1.svg";